import { Icon, type IconProps } from './Icon';

export function Phone(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4.5 4.5h3l2 5-2.5 1.5a12 12 0 0 0 6 6l1.5-2.5 5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 2.5 6.5a2 2 0 0 1 2-2z" />
    </Icon>
  );
}
